import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Home from './Home';
import EquipmentDetail from './EquipmentDetail';
import registerServiceWorker from './registerServiceWorker';
// import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { BrowserRouter as Router, Route } from 'react-router-dom';

ReactDOM.render((
  <Router>
    <div>
      <Route exact path="/" component={ App } />
      <Route path="/groups/:groupId/equipments/:equipmentId" component={ EquipmentDetail } />
    </div>
  </Router>
), document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js